import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/styles/index.scss'
import SvgIcon from '@/icons'
import svgicon from '@/components/SvgIcons'
import 'element-plus/dist/index.css'
import './styles/xmProject/product.css'
import './styles/xmProject/information.css'
import '@/styles/xmProject/anm.css'
import 'vue3-json-viewer/dist/index.css'
// 引用字体
import '@/assets/font/font.scss'
import ElementPlus from 'element-plus'
// 全局加载webscoket
// import SocketService from '@/utils/websocket'
// eslint-disable-next-line import/no-duplicates
import SocketService from '@/utils/websocket'
// eslint-disable-next-line import/no-duplicates
// import AutoOtaUpload from '@/utils/autoOtaUpload'
// 注册指令
import plugins from './plugins' // plugins
// 自定义树选择组件
// import 'dayjs/locale/zh-cn' // 中文
import locale from 'element-plus/lib/locale/lang/zh-cn' // 中文
import VueWechatTitle from 'vue-wechat-title'
// import './utils/world' // 引入世界地图
import * as ElIcons from '@element-plus/icons'
import ECharts from 'vue-echarts'
// import { use } from 'echarts/core'
// import { CanvasRenderer } from 'echarts/renderers'
// import { BarChart } from 'echarts/charts'
// import { GridComponent, TooltipComponent } from 'echarts/components'
import VueGridLayout from 'vue-grid-layout'
import { handleTree, resetForm } from '@/utils/index'
// import dataV from '@jiaminghi/data-view'
// import UUID from 'vue-uuid'
import '@/router/permission'
// use([CanvasRenderer, BarChart, GridComponent, TooltipComponent])
const app = createApp(App)
SvgIcon(app)
Object.keys(ElIcons).forEach(function (key) {
  app.component(ElIcons[key].name, ElIcons[key])
})
// 全局方法挂载
app.config.globalProperties.$SocketService = SocketService
// app.config.globalProperties.$AutoOtaUpload = AutoOtaUpload
app.config.globalProperties.handleTree = handleTree
app.config.globalProperties.resetForm = resetForm
app.use(ElementPlus, { locale })
app.use(VueWechatTitle)
app.component('v-chart', ECharts)
app.component('svg-icon', svgicon)
// app.use(UUID)
// app.use(dataV)
app.use(store).use(router).use(VueGridLayout).use(plugins).mount('#app')
